import * as angular from 'angular';
import { migratedComfortBids } from 'angular/utils/migrated-comfort-bids';

class ComfortBidWizardToggleComponentCtrl implements ng.IController {
    public migratedComfortBids = migratedComfortBids;
    public comfortBidId?: number;

    constructor() {}

    $onInit(): void {
        if (migratedComfortBids.isNewDesignActive) {
            migratedComfortBids.goToNewDesign();
        }
    }
}

angular.module('app').component('pkpComfortBidWizardToggle', {
    controller: ComfortBidWizardToggleComponentCtrl,
    template: require('app/comfort-bid/comfort-bid-wizard-toggle.component.html'),
    bindings: {
        comfortBidId: '<?'
    }
});
